/**
 * The Quran's language lives in its URL, so a link always opens in the
 * language it was shared in: /quran/… is English, /bs/quran/… Bosnian,
 * /de/quran/… German, /nl/quran/… Dutch, /fr/quran/… French.
 * Pure (no Vue, no browser APIs): the build imports it too.
 */
export const QURAN_LOCALES = ['en', 'bs', 'de', 'nl', 'fr'];

/** Each language in its own name, for language menus. */
export const LOCALE_NAMES = { en: 'English', bs: 'Bosanski', de: 'Deutsch', nl: 'Nederlands', fr: 'Français' };

export const DEFAULT_QURAN_LOCALE = 'en';

export const localePrefix = (locale) => (locale === DEFAULT_QURAN_LOCALE ? '' : `/${locale}`);

/** "/bs/quran/2/" → "/quran/2/" */
export const stripLocale = (path) => path.replace(/^\/(?:bs|de|nl|fr)(?=\/)/, '');

/** The same page in another language. */
/** Numbers and dates in a language; Bosnian shares German's separators, and browsers often lack Bosnian. */
export const intlLocale = (locale) => ({ en: 'en-US', bs: 'de-DE', de: 'de-DE', nl: 'nl-NL', fr: 'fr-FR' })[locale] ?? 'en-US';

export const inLocale = (path, locale) => `${localePrefix(locale)}${stripLocale(path)}`;
